import React from 'react';

const UpArrow = () => (
  <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.825 6.17502L5 2.35834L1.175 6.17502L2.38419e-07 5.00001L5 3.47698e-08L10 5.00001L8.825 6.17502Z"
      fill="#505050"
    />
  </svg>
);

export default UpArrow;
